var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 776.3,
    height: 219.3,
    viewBox: "0 0 776.3 219.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-2882.8 399.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "azure-logo",
    transform: "translate(2882 -400)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M320.7,129.7l33.5,88.9h-17l-7.9-22.1h-35l-7.6,22.1H269.8l33.5-88.9Zm-9.2,16.4-13.1,37.4H325l-13-37.4Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M361.7,154.8h50.9v6l-33.4,45.8h33.6v11.9H359.4v-7.1l32.9-44.7H361.7Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M476.6,154.8v63.7H461.5v-8.4h-.2a20.275,20.275,0,0,1-8,6.8,24.064,24.064,0,0,1-11.2,2.4c-7.4,0-13-2.1-16.9-6.3s-5.8-10.7-5.8-19.5V154.8h15.2v36.9c0,5.4,1.1,9.4,3.2,12.1s5.3,4.1,9.6,4.1a12.818,12.818,0,0,0,10.2-4.5c2.6-3,3.8-6.9,3.8-11.7V154.8Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M521.7,153.8c1.1,0,2.2.1,3.2.2a10.548,10.548,0,0,1,2.4.6v15.2a11.709,11.709,0,0,0-3.4-1.6,17.046,17.046,0,0,0-5.5-.8,11.6,11.6,0,0,0-9.3,4.6c-2.5,3.1-3.8,7.9-3.8,14.3v32.2h-15V154.8h15v10h.2a16.5,16.5,0,0,1,16.2-11Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M581.3,202.5v12.3a31.137,31.137,0,0,1-9.7,3.8,55.285,55.285,0,0,1-12.8,1.5c-9.7,0-17.3-2.9-22.6-8.6q-8.1-8.55-8.1-24c0-9.9,2.9-18,8.6-24.4a28.112,28.112,0,0,1,21.9-9.6c8.8,0,15.6,2.7,20.5,8.1s7.3,12.8,7.3,22.3v7.3H542.8c.7,6.4,2.7,10.9,6.2,13.4s7.9,3.8,13.4,3.8a32.613,32.613,0,0,0,10.3-1.6A34.621,34.621,0,0,0,581.3,202.5Zm-9.6-22.3c0-5-1.1-8.7-3.4-11.3s-5.5-3.9-9.7-3.9a14.036,14.036,0,0,0-9.7,3.9c-2.8,2.6-4.8,6.4-5.7,11.4Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M371.3,7.5V96.4H355.9V26.7h-.2L328.1,96.4H317.9L289.6,26.7h-.2V96.4H275.1V7.5h22.1l25.5,65.9h.4l27-65.9Zm12.9,6.8a8.108,8.108,0,0,1,2.7-6.2,9.345,9.345,0,0,1,6.4-2.5,9.207,9.207,0,0,1,6.6,2.6,8.378,8.378,0,0,1,2.6,6.2,7.9,7.9,0,0,1-2.7,6.1,9.781,9.781,0,0,1-6.5,2.5,8.884,8.884,0,0,1-6.5-2.5,9.143,9.143,0,0,1-2.6-6.2Zm16.6,18.4V96.4h-15V32.7Zm45.5,52.8a23.788,23.788,0,0,0,7.4-1.5,28.074,28.074,0,0,0,7.4-4.1V93.8a30.78,30.78,0,0,1-8.1,3.1A47.868,47.868,0,0,1,443,98c-9.4,0-17-3-22.9-8.9s-8.8-13.5-8.8-22.7c0-10.2,3-18.7,9-25.3s14.5-9.9,25.5-9.9a34.765,34.765,0,0,1,8.5,1.1,26.368,26.368,0,0,1,6.8,2.5V49a32.757,32.757,0,0,0-7.1-3.9,21.108,21.108,0,0,0-7.4-1.4c-5.9,0-10.7,1.9-14.3,5.8s-5.5,9-5.5,15.5c0,6.4,1.7,11.5,5.2,15.1s8.3,5.4,14.3,5.4Zm57.5-53.9c1.1,0,2.2.1,3.2.2a10.548,10.548,0,0,1,2.4.6V47.6A11.708,11.708,0,0,0,506,46a17.045,17.045,0,0,0-5.5-.8,11.6,11.6,0,0,0-9.3,4.6c-2.5,3.1-3.8,7.9-3.8,14.3V96.3h-15V32.6h15v10h.2a17.217,17.217,0,0,1,6.2-8.1,16.752,16.752,0,0,1,10-2.9Zm6.4,33.8c0-10.5,3-18.9,8.9-25,5.9-6.2,14.2-9.2,24.8-9.2,10,0,17.7,3,23.3,8.9s8.4,13.9,8.4,24c0,10.3-3,18.6-8.9,24.7s-14,9.2-24.3,9.2c-9.9,0-17.7-2.9-23.5-8.7-5.8-5.9-8.7-13.8-8.7-23.9Zm15.6-.5c0,6.7,1.5,11.7,4.5,15.2s7.3,5.3,13,5.3c5.5,0,9.6-1.8,12.5-5.3,2.8-3.5,4.3-8.7,4.3-15.6s-1.5-12-4.4-15.5c-3-3.5-7.1-5.2-12.4-5.2-5.5,0-9.8,1.8-12.8,5.5-3.2,3.6-4.7,8.9-4.7,15.6ZM598,49.4a6.158,6.158,0,0,0,2,5c1.4,1.2,4.4,2.8,9,4.6q9,3.6,12.6,8.1A17.034,17.034,0,0,1,625.2,78a17.351,17.351,0,0,1-6.9,14.4c-4.6,3.6-10.8,5.5-18.7,5.5a43.969,43.969,0,0,1-8.8-1,37.755,37.755,0,0,1-8.1-2.4V79.8a36.577,36.577,0,0,0,8.8,4.5,27.394,27.394,0,0,0,8.6,1.7c3.4,0,5.9-.5,7.5-1.4a5.148,5.148,0,0,0,2.4-4.8,6.539,6.539,0,0,0-2.5-5.2c-1.7-1.4-4.8-3.1-9.5-4.9-5.5-2.3-9.5-4.9-11.8-7.8a17.6,17.6,0,0,1-3.5-11,17.57,17.57,0,0,1,6.8-14.2c4.6-3.7,10.5-5.5,17.8-5.5a47.563,47.563,0,0,1,7.5.7,32,32,0,0,1,6.9,1.9V48a31.592,31.592,0,0,0-6.9-3.4,23.467,23.467,0,0,0-7.9-1.4,11.4,11.4,0,0,0-6.7,1.7,5.01,5.01,0,0,0-2.2,4.5Zm33.7,16c0-10.5,3-18.9,8.9-25,5.9-6.2,14.2-9.2,24.8-9.2,10,0,17.7,3,23.3,8.9s8.4,13.9,8.4,24c0,10.3-3,18.6-8.9,24.7s-14,9.2-24.3,9.2c-9.9,0-17.7-2.9-23.5-8.7-5.8-5.9-8.7-13.8-8.7-23.9Zm15.7-.5c0,6.7,1.5,11.7,4.5,15.2s7.3,5.3,13,5.3c5.5,0,9.6-1.8,12.5-5.3,2.8-3.5,4.3-8.7,4.3-15.6s-1.5-12-4.4-15.5c-3-3.5-7.1-5.2-12.4-5.2-5.5,0-9.8,1.8-12.8,5.5-3.2,3.6-4.8,8.9-4.7,15.6Zm99.5-20H724.6V96.3H709.4V44.9H698.7V32.6h10.7V23.7c0-6.7,2.2-12.2,6.5-16.5,4.4-4.3,9.9-6.4,16.8-6.4a38.662,38.662,0,0,1,4.8.3,22.09,22.09,0,0,1,3.7.8v13a20.289,20.289,0,0,0-2.6-1.1,15.4,15.4,0,0,0-4.3-.6,9.228,9.228,0,0,0-7.3,2.9c-1.7,2-2.5,4.9-2.5,8.7v7.7h22.3V18.2l15.1-4.6V32.5h15.2V44.8H762V74.6c0,3.9.7,6.7,2.1,8.3s3.7,2.4,6.7,2.4a8.149,8.149,0,0,0,3.1-.6,18.666,18.666,0,0,0,3.2-1.5V95.6a19.794,19.794,0,0,1-4.7,1.5,35.9,35.9,0,0,1-6.5.7c-6.3,0-11.1-1.7-14.2-5-3.2-3.4-4.7-8.4-4.7-15.2Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(0.8 7.5)",
    fill: "#f25022"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(111.6 7.5)",
    fill: "#7fba00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(0.8 118.2)",
    fill: "#00a4ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(111.6 118.2)",
    fill: "#ffb900"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(0.8 7.5)",
    fill: "#f25022"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-6",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(111.6 7.5)",
    fill: "#7fba00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(0.8 118.2)",
    fill: "#00a4ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    "data-name": "Rectangle",
    width: 100.3,
    height: 100.3,
    transform: "translate(111.6 118.2)",
    fill: "#ffb900"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.1e82e4a3ef771935dd9889f67bb962c6.svg";
export { ForwardRef as ReactComponent };